import { render, staticRenderFns } from "./DropDownButton.vue?vue&type=template&id=226b792b&"
import script from "./DropDownButton.vue?vue&type=script&lang=js&"
export * from "./DropDownButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports